/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_AlternativesInputs */

const en_footer_alternatives = /** @type {(inputs: Footer_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternatives`)
};

const zh_hans1_footer_alternatives = /** @type {(inputs: Footer_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`替代方案`)
};

const pt_br2_footer_alternatives = /** @type {(inputs: Footer_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternativas`)
};

const es_footer_alternatives = /** @type {(inputs: Footer_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternativas`)
};

const fr_footer_alternatives = /** @type {(inputs: Footer_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternatives`)
};

const de_footer_alternatives = /** @type {(inputs: Footer_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternativen`)
};

const ru_footer_alternatives = /** @type {(inputs: Footer_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Альтернативы`)
};

const it_footer_alternatives = /** @type {(inputs: Footer_AlternativesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternative`)
};

/**
* | output |
* | --- |
* | "Alternatives" |
*
* @param {Footer_AlternativesInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_alternatives = /** @type {((inputs?: Footer_AlternativesInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_AlternativesInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_alternatives(inputs)
	if (locale === "pt-BR") return pt_br2_footer_alternatives(inputs)
	if (locale === "es") return es_footer_alternatives(inputs)
	if (locale === "fr") return fr_footer_alternatives(inputs)
	if (locale === "de") return de_footer_alternatives(inputs)
	if (locale === "ru") return ru_footer_alternatives(inputs)
	if (locale === "it") return it_footer_alternatives(inputs)
	return en_footer_alternatives(inputs)
});